import React from 'react';
import { useTranslation } from 'react-i18next';
import { MoneyIcon } from '../../../ui-kit';
// import { routePaths } from '../../../routePaths';
import AccordionRow from './AccordionRow';
import { ProductCosts } from './types';

interface ProductCostSummaryProps {
    productPrimeCosts: ProductCosts['withVat'] | ProductCosts['withoutVat'];
}

const ProductCostSummary = ({ productPrimeCosts }: ProductCostSummaryProps) => {
    const { t } = useTranslation();

    // const linkUrl = routePaths.dashboardProductsReport;
    return (
        <AccordionRow
            Icon={MoneyIcon}
            title={t('Products sold costs')}
            color='purple'
            amount={productPrimeCosts}
            // linkUrl={linkUrl}
            appendMinusToAmount
        />
    );
};

export default ProductCostSummary;